import {StateCreator} from "zustand";
import {WorkLogItem} from "@/pb/api/devplan/types/worklog";
import {workLogProjectEntriesAPI} from "@/app/apiPaths";
import {GetProjectWorkLogEntriesResponse} from "@/pb/api/devplan/services/web/company";
import {jr} from "@/hooks/queries/response-handler";

export interface WorkLogStoreState {
  projectWorkLogs: Record<string, WorkLogItem[]>;

  fetchProjectWorkLog(companyId: number, projectId: string): Promise<void>;
}

export const createWorkLogSlice: StateCreator<
  WorkLogStoreState,
  [],
  [],
  WorkLogStoreState
> = (set) => ({
  projectWorkLogs: {},
  fetchProjectWorkLog: async (companyId, projectId) => fetch(workLogProjectEntriesAPI(companyId, projectId))
    .then(jr)
    .then(js => {
      const {entries} = GetProjectWorkLogEntriesResponse.fromJSON(js)
      set(s => ({...s, projectWorkLogs: {...s.projectWorkLogs, [projectId]: entries}}))
    })
});
